export enum ApiName {
  plutoApi = 'plutoApi',
  plutoAvailabilityApi = 'plutoAvailabilityApi',
}
